// test1388
(1388 && 0);
